import {Paper, Typography} from "@mui/material";
import {Container} from "@mui/system";
import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import Footer from "./Footer";
import React from "react";
import {versoMebelAboutParagraphs, versoMebelContacts} from "../../data/ContactsVersoMebel";
import {isKuhniVersoMebelDomain, kuhniVersoTabletContainerQuerySx} from "../../utils/isKuhniVersoMebelDomain";

const MEDIA_MAX_1450 = "@media (max-width: 1450px)";
const MEDIA_MAX_1280 = "@media (max-width: 1280px)";
const MEDIA_MAX_1023 = "@media (max-width: 1023px)";

const sectionTitleSx = {
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: 1,
    [MEDIA_MAX_1450]: {
        fontSize: "28px",
    },
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
};

const contactLinkSx = {
    fontSize: "16px",
    [MEDIA_MAX_1450]: {
        fontSize: "14px",
    },
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "nowrap",
    },
    "& a": {
        color: (theme) => theme.palette.primary.main,
        textDecoration: "none",
    },
};

const phoneLinkSx = {
    fontSize: "18px",
    fontWeight: 500,
    [MEDIA_MAX_1450]: {
        fontSize: "16px",
    },
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "nowrap",
    },
    "& a": {
        color: (theme) => theme.palette.primary.main,
        textDecoration: "none",
    },
};

const upMeLegalSx = {
    fontSize: "16px",
    color: (theme) => theme.palette.text.main,
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "nowrap",
    },
};

const aboutParagraphSx = {
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: 1.2,
    color: (theme) => theme.palette.text.main,
    [MEDIA_MAX_1450]: {
        fontSize: "22px",
    },
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        width: "100%",
    },
};

const versoPhoneLinkSx = {
    fontSize: "22px",
    fontWeight: 500,
    lineHeight: 1.2,
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "nowrap",
    },
    "& a": {
        color: (theme) => theme.palette.primary.main,
        textDecoration: "none",
    },
};

const versoContactLinkSx = {
    fontSize: "22px",
    lineHeight: 1.2,
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "nowrap",
    },
    "& a": {
        color: (theme) => theme.palette.primary.main,
        textDecoration: "none",
    },
};

const versoAddressSx = {
    fontSize: "22px",
    lineHeight: 1.5,
    color: (theme) => theme.palette.text.main,
    [MEDIA_MAX_1280]: {
        fontSize: "20px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "normal",
    },
};

const versoUnpSx = {
    fontSize: "20px",
    lineHeight: 1.2,
    color: (theme) => theme.palette.text.main,
    [MEDIA_MAX_1023]: {
        fontSize: "18px",
        whiteSpace: "normal",
    },
};

const contactsSectionsRowSx = {
    display: "flex",
    alignItems: "flex-start",
    gap: "36px",
    width: "100%",
    minWidth: 0,
    [MEDIA_MAX_1023]: {
        flexDirection: "column",
        gap: "24px",
        width: "100%",
        alignItems: "stretch",
    },
};

const contactsSectionSx = {
    display: "flex",
    flexDirection: "column",
    gridGap: "40px",
    justifyContent: "center",
    flex: "0 4 400px",
    maxWidth: "400px",
    minWidth: "min-content",
    [MEDIA_MAX_1280]: {
        flex: "1 1 auto",
        minWidth: "min-content",
        maxWidth: "400px",
        width: "max-content",
    },
    [MEDIA_MAX_1023]: {
        flex: "1 1 auto",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        gridGap: "24px",
    },
};

const contactsAboutSectionSx = {
    display: "flex",
    flexDirection: "column",
    gridGap: "24px",
    justifyContent: "center",
    flex: "1 1 0",
    minWidth: 0,
    maxWidth: "800px",
    [MEDIA_MAX_1280]: {
        flex: "0 0 700px",
        width: "700px",
        maxWidth: "700px",
    },
    [MEDIA_MAX_1023]: {
        flex: "1 1 auto",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        gridGap: "16px",
    },
};

const contactsContentSx = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    [MEDIA_MAX_1023]: {
        flex: "1 1 auto",
        width: "auto",
        maxWidth: "100%",
        minWidth: 0,
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        columnGap: "24px",
        rowGap: "4px",
    },
};

const contactsContentPrimaryColumnSx = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    [MEDIA_MAX_1023]: {
        flex: "0 0 auto",
        width: "auto",
    },
};

const contactsContentSecondaryColumnSx = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    [MEDIA_MAX_1023]: {
        flex: "0 0 auto",
        width: "auto",
    },
};

const aboutParagraphsContainerSx = {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
    [MEDIA_MAX_1023]: {
        gap: "16px",
    },
};

const UpMeContactsBlock = () => (
    <Box sx={contactsContentSx}>
        <Box sx={contactsContentPrimaryColumnSx}>
            <Typography component="p" sx={contactLinkSx}>
                email: <a href="mailto:info@upme.by">info@upme.by</a>
            </Typography>
            <Typography component="p" sx={phoneLinkSx}>
                +375 44 73 24 144
            </Typography>
        </Box>
        <Box sx={contactsContentSecondaryColumnSx}>
            <Typography sx={upMeLegalSx}>
                ООО «АЙТИ ДЖУС» УНП: 591397311
            </Typography>
        </Box>
    </Box>
);

const VersoContactsBlock = () => (
    <Box sx={contactsContentSx}>
        <Box sx={contactsContentPrimaryColumnSx}>
            {versoMebelContacts.phones.map((phone) => (
                <Typography key={phone.id} component="p" sx={versoPhoneLinkSx}>
                    <a href={phone.href}>{phone.display}</a>
                </Typography>
            ))}
            <Typography component="p" sx={versoContactLinkSx}>
                email:{" "}
                <a href={`mailto:${versoMebelContacts.email}`}>{versoMebelContacts.email}</a>
            </Typography>
        </Box>
        <Box sx={contactsContentSecondaryColumnSx}>
            <Box sx={{display: "flex", flexDirection: "column", gap: 0}}>
                {versoMebelContacts.address.map((line, index) => (
                    <Typography
                        key={index}
                        component="p"
                        sx={{
                            ...versoAddressSx,
                            lineHeight: 1.1,
                            m: 0,
                        }}
                    >
                        {line}
                    </Typography>
                ))}
            </Box>
            <Typography sx={versoUnpSx}>
                УНП: {versoMebelContacts.unp}
            </Typography>
        </Box>
    </Box>
);

const Contacts = () => {
    const isKuhniVersoMebel = isKuhniVersoMebelDomain();

    return (
        <>
            <Paper
                sx={{
                    width: "100%",
                    paddingBottom: "40px",
                    display: "flex",
                    justifyContent: "space-between",
                    flexGrow: 1,
                }}
            >
                <Container
                    sx={{
                        "&.MuiContainer-root": {
                            maxWidth: "1668px",
                            display: "flex",
                            flexDirection: "column",
                            gridGap: "100px",
                            ...(isKuhniVersoMebel ? kuhniVersoTabletContainerQuerySx : {}),
                        },
                    }}
                >
                    <Box>
                        <BreadcrumbsComponent
                            page={"Контакты"}
                            path={[{name: "Главная", href: "/"}]}
                        />
                        <Box sx={contactsSectionsRowSx}>
                            <Box sx={contactsSectionSx}>
                                <Typography
                                    sx={[
                                        sectionTitleSx,
                                        {
                                            [MEDIA_MAX_1023]: {
                                                whiteSpace: "nowrap",
                                                width: "min-content",
                                                flex: "0 0 auto",
                                            },
                                        },
                                    ]}
                                >
                                    Контакты
                                </Typography>
                                {isKuhniVersoMebel ? <VersoContactsBlock /> : <UpMeContactsBlock />}
                            </Box>
                            <Box sx={contactsAboutSectionSx}>
                                <Typography sx={[sectionTitleSx, {[MEDIA_MAX_1023]: {width: "100%"}}]}>
                                    О компании
                                </Typography>
                                {isKuhniVersoMebel && (
                                    <Box sx={aboutParagraphsContainerSx}>
                                        {versoMebelAboutParagraphs.map((paragraph) => (
                                            <Typography
                                                key={paragraph.id}
                                                component="p"
                                                sx={aboutParagraphSx}
                                            >
                                                {paragraph.text}
                                            </Typography>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Paper>
            <Footer />
        </>
    );
};

export default Contacts;
